import React from 'react';
import InfoListingPage from '../components/InfoListingPage';

const items = [
  {
    title: 'Getting Around Plymouth',
    distance: '',
    image: '091bc7519f30f28b0c6d3411bd97fd6b.jpg',
    description: 'Plymouth has many transport options for you to be able to get around easily, ensuring you can visit the many quarters and attractions the ocean city has to offer.'
  },
  {
    title: 'Water Links',
    distance: '',
    image: 'waterLinks.jpg',
    description: 'Take the opportunity to step on board the Plymouth Waterlink to create the perfect day out, enjoying the stunning coastline scenery whilst exploring local and nearby attractions.\n\nExplore this city by water with ferries and water taxis throughout the year connecting the Barbican Harbour, the Hoe, Mount Batten and the Royal William Yard, as well as Mount Edgcumbe and Cawsands in Cornwall.'
  },
  {
    title: 'Park & Ride',
    distance: '',
    image: 'Park&Ride.jpg',
    description: 'There are 5 park and ride sites in Plymouth, these services depart from 07:30 till 18:30 from:\n\n- Coypool P&R, Ridge Way\n- George Junction Park & Ride\n- Milehouse Park & Ride\n\nThis is a good option if you plan on spending the whole day in the city because all bus services in Plymouth offer flat all day parking.\n\nCurrent preferred service and local prices can be checked on the Plymouth website.'
  },
  {
    title: 'Bus Services',
    distance: '',
    image: 'BusServices.jpg',
    description: 'Plymouth’s local buses connect the hotel with many key places in the city. You can also reach nearby towns and areas with regular scheduled routes.\n\nThe Royal Parade bus stops are a short distance away and are the central hub for many of the city’s local services.\n\nFor more flexibility during your trip here, there are longer distance operators including coaches and regional services.'
  },
  {
    title: 'Bike Hire',
    distance: '',
    image: 'BikeHire.jpg',
    description: 'Fancy seeing the beautiful sights of Plymouth by bike? There are cycle hire and scooter hire options available around the city.\n\nScooter hire requires balance and is especially good for those who can stand and who feel confident riding on roads. Prices start from a few pounds for a short rental.'
  },
  {
    title: 'Taxi',
    distance: '',
    image: 'Slider1.jpg',
    description: 'Taxi and private hire services are available throughout Plymouth, giving you a quick and comfortable way to travel to and from the hotel and around the city.'
  },
  {
    title: 'Bus & Coach Station',
    distance: '',
    image: 'Slider1.jpg',
    description: 'The main bus and coach station is located just a short distance from the hotel, making arrivals and onward travel straightforward for guests.'
  }
];

const GettingToHotel = () => (
  <InfoListingPage
    title="Getting to the Grosvenor Hotel Plymouth"
    description="Useful travel information to help you reach Grosvenor Plymouth and get around the city with ease during your stay."
    items={items}
  />
);

export default GettingToHotel;
